import { columns } from './columns';
import { filters } from './filters';
import { query } from './query';

const errorDetailConfig = {
    columns,
    filters,
    queryFilter: query,
};

export default errorDetailConfig;
